module.exports = __webpack_public_path__ + "static/media/ordercomplete.e34eab0b.png";